var map = {
	"./Aeroport.svg": "a782",
	"./Aire de jeux.svg": "df2f",
	"./Auto partage.svg": "0cef",
	"./Aéroport.svg": "6904",
	"./Banque.svg": "1ad5",
	"./Bar.svg": "4c6e",
	"./Bibliothèque.svg": "4f12",
	"./Bijouterie.svg": "71ba",
	"./Boucher.svg": "aca0",
	"./Boulangerie.svg": "d893",
	"./Boutique de souvenirs.svg": "dd28",
	"./Bureau de poste.svg": "676d",
	"./Bus.svg": "5730",
	"./Bâtiment public.svg": "5f01",
	"./Café.svg": "d123",
	"./Camping caravane.svg": "0d3f",
	"./Camping.svg": "8477",
	"./Centre commercial.svg": "76d1",
	"./Centre sportif.svg": "8304",
	"./Château.svg": "817b",
	"./Cinéma.svg": "eb6e",
	"./Coiffeur.svg": "db35",
	"./Commerce de proximité.svg": "abad",
	"./Commissariat.svg": "01be",
	"./Cosmétique.svg": "fda8",
	"./Crèche.svg": "e8d8",
	"./Dentiste.svg": "ca9fe",
	"./Distributeur.svg": "a208",
	"./Enseignement supérieur.svg": "2cd4",
	"./Enseignement.svg": "4e4b",
	"./Epicerie.svg": "9c76",
	"./Equipement sportif.svg": "d25c",
	"./Fleuriste.svg": "70a8",
	"./Garderie.svg": "c28d",
	"./Groupe scolaire.svg": "a35d",
	"./Hypermarché.svg": "2c8b",
	"./Hôpital.svg": "e225",
	"./Hôtel de ville.svg": "f266",
	"./Hôtel.svg": "84e4",
	"./Jardinerie.svg": "3ea3",
	"./La Poste.svg": "21c2",
	"./Librairie.svg": "a957",
	"./Location de voiture.svg": "ff89",
	"./Magasin de bricolage.svg": "75df",
	"./Magasin de chaussures.svg": "150a",
	"./Magasin de jouets.svg": "cd0f",
	"./Magasin de meubles.svg": "aa5c",
	"./Magasin de sport.svg": "b081",
	"./Magasin de téléphonie.svg": "e117",
	"./Magasin de vêtements.svg": "0b8e",
	"./Maison de repos.svg": "cfe5",
	"./Maisons de repos.svg": "7bf1",
	"./Marchand de journaux.svg": "bc7a",
	"./Metro.svg": "9936",
	"./Musée.svg": "3175",
	"./Mutation.svg": "84fa",
	"./Médecin.svg": "d87a",
	"./Médecins.svg": "6ced",
	"./Office du tourisme.svg": "5d05",
	"./Opticien.svg": "5ad8",
	"./Papeterie.svg": "8f7d",
	"./Parc d'attractions.svg": "5c68",
	"./Parc.svg": "cf44",
	"./Patinoire.svg": "901d",
	"./Pharmacie.svg": "27b8",
	"./Piscine.svg": "00a3",
	"./Police.svg": "afa1",
	"./Port_de_plaisance.svg": "43ba",
	"./Primeur.svg": "2988",
	"./Prison.svg": "3128",
	"./Projet étudié.svg": "e6d7",
	"./Restaurant.svg": "8e86",
	"./Salon de beauté.svg": "4a03",
	"./Sous-préfecture.svg": "ae55",
	"./Stade.svg": "3859",
	"./Station service.svg": "c639",
	"./Supermarché.svg": "27be",
	"./Supérette_Supermarché.svg": "7b9a",
	"./Tabac - Presse.svg": "49ea",
	"./Tabac _ Presse.svg": "0260",
	"./Terrain de golf.svg": "d198",
	"./Terrain de sport.svg": "f721",
	"./Théâtre.svg": "e011",
	"./Train.svg": "d56d0",
	"./Tram.svg": "1d6d",
	"./Transport bus.svg": "8fea",
	"./Transport métro.svg": "7a1b",
	"./Transport piéton.svg": "9171",
	"./Transport train.svg": "5f98",
	"./Transport tramway.svg": "0c65",
	"./Transport véhicules.svg": "86d8",
	"./Tribunal.svg": "fd71",
	"./Université.svg": "c248",
	"./Vendeur auto.svg": "b89c",
	"./Zoo.svg": "3426",
	"./default.svg": "1a4e",
	"./education.svg": "a1ee",
	"./projet.svg": "23df",
	"./skiing.svg": "9527"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "944d";